import React, { useState, useEffect } from "react";
import { Link, useNavigate } from "react-router-dom";
import axios from "axios";
import "./DailyVegGrid.css";

const HomeVegetables = () => {
  const [products, setProducts] = useState([]);
  const [selectedWeights, setSelectedWeights] = useState({});
  const [error, setError] = useState("");
  const navigate = useNavigate();

  const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;

  useEffect(() => {
    const fetchHomeCategoryProducts = async () => {
      try {
        const response = await axios.get(`${API_BASE_URL}/api/products/category/home`);
        setProducts(response.data);
      } catch (error) {
        console.error("Error fetching home category products:", error);
        setError("Failed to load home category products.");
      }
    };
    fetchHomeCategoryProducts();
  }, [API_BASE_URL]);

  const handleWeightChange = (index, label) => {
    const weightObj = products[index].weights.find((w) => w.weight === label);
    setSelectedWeights((prev) => ({ ...prev, [index]: weightObj }));
  };

  const handleAddToCart = async (product, selected) => {
    const token = localStorage.getItem("token");
    if (!token) {
      navigate("/login");
      return;
    }
    try {
      await axios.post(
        `${API_BASE_URL}/api/cart/add`,
        {
          productId: product._id,
          name: product.name,
          image: product.images[0],
          weight: selected.weight,
          price: selected.price,
          quantity: 1,
        },
        { headers: { Authorization: `Bearer ${token}` } }
      );
    } catch (error) {
      console.error("Error adding to cart:", error);
    }
  };

  if (error) {
    return (
      <div className="veg-error" style={{ textAlign: "center", padding: "2rem", color: "#dc2626" }}>
        {error}
      </div>
    );
  }

  if (products.length === 0 && !error) {
    return null;
  }

  return (
    <div className="veg-grid-wrapper">
      <div className="veg-grid">
        {products.map((product, index) => {
          const selected = selectedWeights[index] || product.weights[0];
          return (
            <div key={product._id} className="veg-item">
              <div className="card veg-card text-center h-100 p-3">
                <img
                  src={product.images[0]}
                  alt={product.name}
                  className="mb-2 img-fluid rounded-3"
                />
                <h6 className="product-name">{product.name}</h6>
                <select
                  className="form-select weight-selector my-2"
                  value={selected.weight}
                  onChange={(e) => handleWeightChange(index, e.target.value)}
                >
                  {product.weights.map((w) => (
                    <option key={w.weight} value={w.weight}>
                      {w.weight}
                    </option>
                  ))}
                </select>
                <p className="price-original"> ₹ {selected.price}</p>
                <Link
                  to={`/product/${product._id}`}
                  className="mb-2 d-inline-flex text-decoration-none view-detail-link"
                >
                  View Detail <i className="bi bi-chevron-right ms-1"></i>
                </Link>
                <button
                  className="btn rounded px-3 mb-2 py-2 add-cart-btn"
                  onClick={() => handleAddToCart(product, selected)}
                >
                  <i className="bi bi-cart-plus me-2"></i>
                  <span>Add </span>
                </button>
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default HomeVegetables;